// Automatically included in './src/main.js'

import './amplify'
import './base'
import './meta'
import './vue-tel-input'
import './webfontloader'
